import { CheckoutStatusError } from '@/models/api/Order';
import { AddressData, ProvinceData } from '@/models/api/ProfileInfo';
import { AppService } from '@/services';

export function validateShippingAddress(data: AddressData, provinces?: ProvinceData[]) {
    const requiredAddressFields = ['street', 'buildingNo', 'zipCode', 'city', 'mobile'];

    const missingFields = requiredAddressFields.filter((fieldName) => {
        const value = data[fieldName as keyof AddressData];
        return typeof value !== 'string' || !value.trim();
    });

    if (!data.email) {
        missingFields.push('email');
    }

    if (AppService.isRomaniaInstance() && provinces?.length) {
        if (!data.province?.trim()) {
            missingFields.push('province');
        } else {
            const provinceDistricts =
                provinces.find((p) => p.name === data.province)?.districts ?? [];
            if (provinceDistricts.length > 0 && !data.district?.trim()) {
                missingFields.push('district');
            }
        }
    }

    if (!missingFields.length) {
        return null;
    }

    return {
        title: CheckoutStatusError.MissingAddressData,
        list: missingFields
    };
}

export function validateInpostShippingAddress(data: AddressData) {
    const requiredAddressFields = ['inpostLocker', 'name', 'surname', 'mobile', 'email'];

    const missingFields = requiredAddressFields.filter((fieldName) => {
        const value = data[fieldName as keyof AddressData];
        return typeof value !== 'string' || !value.trim();
    });

    if (!missingFields.length) {
        return null;
    }

    return {
        title: CheckoutStatusError.MissingAddressDataLocker,
        list: missingFields
    };
}
